import * as MapGL from 'react-map-gl/mapbox';
import { useSnapshot } from 'valtio';
import { addToken, addTokenToImageValue } from '~/api/layers2';
import getConfig from '~/config';
import layerStore from '~/store2/layers';
import { FIBER_LIT_BUILDINGS_MAX_ZOOM, FIBER_LIT_BUILDINGS_MIN_ZOOM } from '~/store2/layerZoom';

const config = getConfig();

export default function FiberLitBuildingsLayer({ projectId }: { projectId: string }) {
  const { visibleLayerIds, tilesConfig } = useSnapshot(layerStore) as typeof layerStore;
  if (!visibleLayerIds.has('fiberLitBuildings')) return null;

  // The yellow icon is provided via the existing tilesConfig.fiberLitBuildings
  // legend metadata served by the tile server. The ESRI tile URL was removed,
  // but the legend / icon entries are still served.
  const fiberLitConfig = tilesConfig?.fiberLitBuildings;
  const fiberLitSymbolLayer =
    fiberLitConfig && fiberLitConfig.type === 'vector'
      ? fiberLitConfig.layers.find((l) => l.type === 'symbol')
      : undefined;
  const iconImage = fiberLitSymbolLayer?.layout?.['icon-image'];

  return (
    <MapGL.Source
      id="fiberLitBuildings"
      type="vector"
      tiles={[addToken(`${config.tileServerBase}/v1/tiles/fiberLitBuildings/{z}/{x}/{y}.mvt?projectId=${projectId}`)]}
      minzoom={FIBER_LIT_BUILDINGS_MIN_ZOOM}
      maxzoom={FIBER_LIT_BUILDINGS_MAX_ZOOM}
    >
      {iconImage ? (
        <MapGL.Layer
          id="fiberLitBuildings"
          source="fiberLitBuildings"
          source-layer="all"
          type="symbol"
          layout={{
            'icon-image': addTokenToImageValue(iconImage),
            'icon-allow-overlap': true,
            'icon-size': ['interpolate', ['linear'], ['zoom'], 12, 0, 14, 0.1, 15, 0.25, 16, 0.45, 17, 0.7, 18, 1],
          }}
        />
      ) : (
        <MapGL.Layer
          id="fiberLitBuildings"
          source="fiberLitBuildings"
          source-layer="all"
          type="circle"
          paint={{
            'circle-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              12,
              0,
              13,
              0.2,
              14,
              0.4,
              15,
              0.8,
              16,
              1.5,
              17,
              2.5,
              18,
              3.5,
            ],
            'circle-color': '#facc15',
            'circle-stroke-width': [
              'interpolate',
              ['linear'],
              ['zoom'],
              12,
              0,
              14,
              0,
              15,
              0.3,
              16,
              0.8,
              17,
              1,
              18,
              1.2,
            ],
            'circle-stroke-color': '#ffffff',
          }}
        />
      )}
    </MapGL.Source>
  );
}
